/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Move_To_FolderInputs */

const en_audio_move_to_folder = /** @type {(inputs: Audio_Move_To_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to folder`)
};

const es_audio_move_to_folder = /** @type {(inputs: Audio_Move_To_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover a carpeta`)
};

/**
* | output |
* | --- |
* | "Move to folder" |
*
* @param {Audio_Move_To_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_move_to_folder = /** @type {((inputs?: Audio_Move_To_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Move_To_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_move_to_folder(inputs)
	return en_audio_move_to_folder(inputs)
});